/** Shared action button sizing for quiz / exercise catalog rows (compact on mobile). */
export const catalogFlowActionBtnSizeClass = 'px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm';

export const catalogFlowActionBtnIconClass = 'h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4';

/** Mobile: centered row with a little space above labels; desktop: end-aligned beside content. */
export const catalogFlowActionBtnRowClass =
  'mt-3 flex flex-wrap items-center justify-center gap-1.5 sm:mt-0 sm:gap-2 sm:flex-nowrap sm:justify-end';

/** Tighter sizing so exercise actions (view lesson / mark / practice) stay on one row. */
export const catalogFlowExerciseActionBtnSizeClass =
  'whitespace-nowrap px-2 py-1 text-[11px] sm:px-2.5 sm:py-1.5 sm:text-xs';

export const catalogFlowExerciseActionBtnIconClass = 'h-3 w-3 shrink-0 sm:h-3.5 sm:w-3.5';

export const catalogFlowExerciseActionBtnRowClass =
  'mt-3 flex flex-nowrap items-center justify-center gap-1 sm:mt-0 sm:gap-1.5 sm:justify-end';
